var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7664 3.98275C13.0093 4.08342 13.2301 4.23098 13.416 4.417L19.584 10.584C19.7701 10.7699 19.9178 10.9907 20.0186 11.2338C20.1194 11.4769 20.1712 11.7374 20.1712 12.0005C20.1712 12.2636 20.1194 12.5241 20.0186 12.7672C19.9178 13.0103 19.7701 13.2311 19.584 13.417L13.416 19.584C13.2301 19.77 13.0093 19.9176 12.7664 20.0182C12.5234 20.1189 12.263 20.1707 12 20.1707C11.737 20.1707 11.4766 20.1189 11.2336 20.0182C10.9906 19.9176 10.7699 19.77 10.584 19.584L4.41598 13.417C4.22982 13.2311 4.08213 13.0103 3.98136 12.7672C3.8806 12.5241 3.82874 12.2636 3.82874 12.0005C3.82874 11.7374 3.8806 11.4769 3.98136 11.2338C4.08213 10.9907 4.22982 10.7699 4.41598 10.584L10.584 4.417C10.7699 4.23098 10.9906 4.08342 11.2336 3.98275C11.4766 3.88207 11.737 3.83025 12 3.83025C12.263 3.83025 12.5234 3.88207 12.7664 3.98275ZM11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5195 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V7.99999C13 7.73478 12.8946 7.48042 12.7071 7.29289C12.5195 7.10535 12.2652 6.99999 12 6.99999C11.7348 6.99999 11.4804 7.10535 11.2929 7.29289C11.1053 7.48042 11 7.73478 11 7.99999V13C11 13.2652 11.1053 13.5196 11.2929 13.7071ZM11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5195 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5195 15.1053 12.2652 15 12 15C11.7348 15 11.4804 15.1053 11.2929 15.2929C11.1053 15.4804 11 15.7348 11 16C11 16.2652 11.1053 16.5196 11.2929 16.7071Z",
    fill: "#090A0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.e938c1f14ba7ff20d892c1a8e1006b49.svg";
export { ForwardRef as ReactComponent };